import axios from "axios";
import { API_BASE_URL } from "../utils/apiRoutes.constant";
import { auth } from "FirebaseSetup";
import { onAuthStateChanged } from "firebase/auth";


// Get token from Firebase auth

const getCurrentUserToken = async () => {
  return new Promise((resolve, reject) => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const token = await user.getIdToken();
          // console.log("User token:", token);
          resolve(token);
        } catch (err) {
          reject(err);
        }
      } else {
        console.log("No user is signed in.");
        resolve(null);
      }
    });
  });
};



const getToken = async () => {
  try {
    
    // If no current user, check localStorage for token
    const localToken = localStorage.getItem('token');
    const currentUserToken = await getCurrentUserToken();


    if (localToken || currentUserToken) {
      localStorage.setItem("token", currentUserToken);
      return currentUserToken;
    }
    
    return null;
  } catch (error) {
    console.error('Error getting token:', error);
    return null;
  }
};

// Create axios instance with interceptors
const api = axios.create({
  baseURL: API_BASE_URL
});

// Request interceptor to add token to all requests
api.interceptors.request.use(
  async (config) => {
    // Don't add token for auth routes (sign in, sign up, etc.)
    const publicRoutes = ['/auth/login', '/auth/forgot-password', '/auth/reset-password'];
    const isPublicRoute = publicRoutes.some(route => config.url?.includes(route));
    console.log(config.url, "config.url");
    if (!isPublicRoute) {
      const token = await getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const apiReq = async (
  path,
  method = "GET",
  body = {},
  baseurl = API_BASE_URL,
  isJsonType = true
) => {
  try {
    if (!path) {
      throw new Error("Missing parameters");
    }


    if(path === "/auth/user/login"){
     console.log("path is /auth/user/login");
    }

    console.log(path, "path_path");
    
    if (method === "GET") {
      return await api
        .get(path, { params: body })
        .then((res) => res)
        .catch((err) => Promise.reject(err));
    } else if (method === "POST") {
      return await api
        .post(path, body, {
          headers: {
            "Content-Type": isJsonType
              ? "application/json"
              : "multipart/form-data"
          },
        })
        .then((res) => res)
        .catch((err) => Promise.reject(err));
    } else if (method === "PATCH") {
      return await api
        .patch(path, body)
        .then((res) => res)
        .catch((err) => Promise.reject(err));
    } else {
      throw new Error("Invalid method: " + method);
    }
  } catch (err) {
    let errorMessage = "Failed to do something exceptional";
    if (err instanceof Error) {
      errorMessage = err.message;
    }
    throw new Error(err.response?.data?.message || errorMessage);
  }
};

// Export the axios instance for direct use
export const apiInstance = api;
